<template>
  <div>
    <v-dialog
      v-model="data.dialogShow"
      fullscreen
      hide-overlay
      transition="dialog-bottom-transition"
    >
      <v-card>
        <v-toolbar class="elevation-1 green lighten-2">
          <v-btn flat icon @click="data.dialogShow = false">
            <font-awesome-icon icon="arrow-left" size="2x" class="black--text" />
          </v-btn>

          <v-spacer></v-spacer>
          <v-toolbar-items></v-toolbar-items>
        </v-toolbar>

        <v-container fluid>
          <v-card class="mb-3 py-3 elevation-1 green lighten-5">
            <v-layout align-start justify-start row wrap>
              <v-flex md6>
                <v-layout align-start justify-start row wrap>
                  <v-flex md4 class="px-3 subHeading font-weight-medium">Username</v-flex>
                  <v-flex
                    md8
                    class="px-3 subHeading font-weight-medium green--text darken-4"
                  >: {{user_name}}</v-flex>
                </v-layout>
                <v-layout align-start justify-start row wrap>
                  <v-flex md4 class="px-3 subHeading font-weight-medium">Nama</v-flex>
                  <v-flex
                    md8
                    class="px-3 subHeading font-weight-medium green--text darken-4"
                  >: {{nama}}</v-flex>
                </v-layout>

                <v-layout align-start justify-start row wrap>
                  <v-flex md4 class="px-3 subHeading font-weight-medium">Tanggal Lahir</v-flex>
                  <v-flex
                    md8
                    class="px-3 subHeading font-weight-medium green--text darken-4"
                  >: {{tanggal_lahir | date}}</v-flex>
                </v-layout>
              </v-flex>
            </v-layout>
          </v-card>

          <v-card class="mb-3 py-3 elevation-1 green lighten-5">
            <v-data-table :headers="headers" :items="items" class="elevation-0 ma-2" hide-actions>
              <template slot="items" slot-scope="props">
                <td class="text-xs-center">{{ props.index + 1}}</td>
                <td class="text-xs-center">
                  <v-btn
                    v-if="props.item.psi_sub_aspec_status==='COMPLETED'"
                    :loading="detail_loading"
                    depressed
                    outline
                    dark
                    color="red"
                    small
                    @click="subAspec_Reset(props.item)"
                  >
                    <v-icon class="mr-2">refresh</v-icon>reset
                  </v-btn>
                </td>
                <td class="text-xs-left" nowrap>{{ props.item.psi_sub_aspec_id }}</td>
                <td class="text-xs-left" nowrap>{{ props.item.sub_aspec_code }}</td>
                <td class="text-xs-left" nowrap>{{ props.item.sub_aspec_nama }}</td>
                <td class="text-xs-left" nowrap>{{ props.item.psi_sub_aspec_status }}</td>

                <td></td>
              </template>
            </v-data-table>
          </v-card>
        </v-container>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import ApiService from "@/common/api.service";
import { format } from "date-fns";

export default {
  props: {
    data: Object
  },
  data: () => ({
    detail_loading: false,
    user_name: "",
    nama: "",
    tanggal_lahir: "",
    headers: [
      {
        text: "No",
        align: "center",
        sortable: false,
        value: "",
        width: "1%",
        class: "subheading font-weight-bold"
      },
      {
        text: "Action",
        align: "center",
        sortable: false,
        value: "",
        width: "1%",
        class: "subheading font-weight-bold"
      },
      {
        text: "Id",
        align: "center",
        sortable: false,
        width: "1%",
        class: "subheading font-weight-bold"
      },
      {
        text: "Kode",
        align: "center",
        sortable: false,
        width: "1%",
        class: "subheading font-weight-bold"
      },
      {
        text: "Nama",
        align: "left",
        sortable: false,
        width: "1%",
        class: "subheading font-weight-bold"
      },
      {
        text: "Status",
        align: "left",
        sortable: false,
        width: "1%",
        class: "subheading font-weight-bold"
      },

      {
        text: "",
        align: "left",
        sortable: false,
        value: "",
        width: "99%",
        class: "subheading font-weight-bold"
      }
    ],
    items: []
  }),
  filters: {
    date: function(value) {
      return format(new Date(value), "DD-MM-YYYY");
    }
  },
  methods: {
    subAspec_Reset: function(param) {
      const vm = this;
      vm.detail_loading = true;

      ApiService.post("Dashboard/DashboardLevel2PsiSubAspec_Reset", {
        psi_sub_aspec_id: param.psi_sub_aspec_id
      })
        .then(response => {
          param.psi_sub_aspec_status = response.data.status;
        })
        .catch(() => {})
        .finally(() => {
          vm.detail_loading = false;
        });
    },
    init: function(param) {
      const vm = this;
      vm.data.detail_loading = true;

      ApiService.post("Dashboard/DashboardLevel2Detail_Init", {
        user_id: param.user_id,
        exercise_id: param.exercise_id
      })
        .then(response => {
          vm.user_name = response.data.header.user_name;
          vm.nama = response.data.header.nama;
          vm.tanggal_lahir = response.data.header.tanggal_lahir;
          vm.items = response.data.detail;
        })
        .catch(() => {})
        .finally(() => {
          vm.data.detail_loading = false;
          vm.data.dialogShow = true;
        });
    }
  }
};
</script>
<style lang="stylus" scoped>
.table-header /deep/ {
  thead {
    background-color: black;
  }
}

.media-menu {
  min-width: 260px;
  border-right: 1px solid #eee;
  min-height: calc(100vh - 50px - 64px);
}

.media-detail {
  min-width: 300px;
  border-left: 1px solid #eee;
}
</style>
